import React, { useEffect } from 'react';
import { TextField } from '@mui/material';
import { CalendarEventDto } from '@/types/calendar';

export interface FormPayload {
  title: string;
  details?: Record<string, any>;
  isValid: boolean;
  isCompleted?: boolean;
}

interface Props {
  disabled: boolean;
  eventToEdit?: CalendarEventDto | null;
  onChange: (payload: FormPayload) => void;
}

export const FeelingForm: React.FC<Props> = ({ disabled, eventToEdit, onChange }) => {
  const [title, setTitle] = React.useState('');

  useEffect(() => {
    setTitle(eventToEdit?.title ?? '');
  }, [eventToEdit]);

  useEffect(() => {
    onChange({ title, isValid: title.trim().length > 0 });
  }, [title]);

  return (
    <TextField
      autoFocus
      margin="dense"
      label="Як ви почуваєтесь?"
      fullWidth
      variant="outlined"
      multiline
      rows={3}
      value={title}
      onChange={(e) => setTitle(e.target.value)}
      disabled={disabled}
    />
  );
};
